/*
 * Rieles del home: flechas, estado de los extremos y previsualizacion.
 *
 * Lo que este archivo NO hace, a proposito:
 *
 *   - No desplaza. El desplazamiento es scroll nativo con scroll-snap, en CSS.
 *     Aqui solo se llama a scrollBy(). Por eso el arrastre tactil, la rueda y el
 *     teclado funcionan aunque este JS no llegue a cargar, y por eso no hay un
 *     indice en memoria que pueda desincronizarse de lo que se ve.
 *   - No autoavanza sin control. Desde el 27/10/2026 (pedido de direccion)
 *     cada riel avanza una tarjeta cada 5 s, pero con lo que el Splide no
 *     tenia y por lo que se quito (WCAG 2.2.2): boton de pausa visible, se
 *     detiene con el cursor encima, con el foco dentro, al deslizarlo, fuera
 *     de la vista y con la pestaña oculta, y no arranca con movimiento
 *     reducido. El avance sigue siendo scrollBy() sobre el scroll nativo.
 *   - No usa jQuery. En el home ya cargado, un $(document).ready() registrado
 *     despues de la carga inicial no se ejecuta.
 *
 * Se carga SOLO con el flag home_riel_v1 encendido.
 */
(function () {
    'use strict';

    var MENOS_MOVIMIENTO = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;

    var HAY_CURSOR = window.matchMedia
        ? window.matchMedia('(hover: hover)')
        : null;

    function suave() {
        return (MENOS_MOVIMIENTO && MENOS_MOVIMIENTO.matches) ? 'auto' : 'smooth';
    }

    /*
     * Un "paso" es el mayor numero entero de tarjetas que cabe a la vista. Se
     * avanza por tarjetas completas y no por un porcentaje del ancho para caer
     * siempre sobre un punto de anclaje: si no, scroll-snap corrige despues el
     * desplazamiento y el movimiento se ve en dos tiempos.
     */
    // Navegadores sin :focus-visible: se trata todo foco como de teclado.
    function focoDeTeclado(nodo) {
        try { return nodo.matches(':focus-visible'); } catch (e) { return true; }
    }

    function paso(riel) {
        var tarjeta = riel.querySelector('.pth-card');
        if (!tarjeta) { return riel.clientWidth; }

        var estilo = window.getComputedStyle(riel);
        var hueco  = parseFloat(estilo.columnGap || estilo.gap) || 0;
        var ancho  = tarjeta.getBoundingClientRect().width + hueco;

        if (!ancho) { return riel.clientWidth; }

        var caben = Math.floor(riel.clientWidth / ancho);
        return Math.max(1, caben) * ancho;
    }

    function montarRiel(fila) {
        var riel = fila.querySelector('.pth-riel');
        var caja = fila.querySelector('.pth-riel-caja');
        if (!riel || !caja) { return; }

        var botones = fila.querySelectorAll('.pth-flecha');
        if (!botones.length) { return; }

        var pendiente = false;

        function actualizar() {
            pendiente = false;

            var maximo = riel.scrollWidth - riel.clientWidth;

            /*
             * Si no se desborda, las flechas sobran. Se ocultan de verdad
             * (hidden) y no solo en apariencia, para que el teclado tampoco se
             * detenga en un control que no lleva a ningun sitio.
             */
            if (maximo <= 1) {
                for (var i = 0; i < botones.length; i++) { botones[i].hidden = true; }
                delete caja.dataset.pthAnt;
                delete caja.dataset.pthSig;
                return;
            }

            var alInicio = riel.scrollLeft <= 1;
            var alFinal  = riel.scrollLeft >= maximo - 1;

            for (var j = 0; j < botones.length; j++) {
                var boton   = botones[j];
                var adelante = boton.getAttribute('data-pth-ir') === '1';
                boton.hidden   = false;
                boton.disabled = adelante ? alFinal : alInicio;
            }

            // Los degradados de los bordes siguen el mismo estado.
            if (alInicio) { delete caja.dataset.pthAnt; } else { caja.dataset.pthAnt = ''; }
            if (alFinal)  { delete caja.dataset.pthSig; } else { caja.dataset.pthSig = ''; }
        }

        function programar() {
            if (pendiente) { return; }
            pendiente = true;
            window.requestAnimationFrame(actualizar);
        }

        var rotacion = montarRotacion(fila, riel);

        for (var k = 0; k < botones.length; k++) {
            botones[k].addEventListener('click', function (evento) {
                var direccion = this.getAttribute('data-pth-ir') === '1' ? 1 : -1;
                riel.scrollBy({ left: direccion * paso(riel), behavior: suave() });
                evento.preventDefault();
                rotacion.reiniciar();
            });
        }

        riel.addEventListener('scroll', programar, { passive: true });

        /*
         * ResizeObserver y no window.resize: el riel tambien cambia de ancho
         * cuando se abre el menu lateral o cuando las imagenes terminan de
         * cargar y empujan el contenido, y eso no dispara resize.
         */
        if (window.ResizeObserver) {
            new window.ResizeObserver(programar).observe(riel);
        } else {
            window.addEventListener('resize', programar);
        }

        actualizar();
    }

    /*
     * Avance automatico de un riel: una tarjeta cada INTERVALO ms.
     *
     * El boton de pausa lo crea este JS y no _fila.php: sin JS no hay rotacion,
     * asi que tampoco debe haber un boton que no haga nada. Va dentro de la fila,
     * arriba a la derecha (ver .pth-pausa en home-riel.css).
     *
     * Devuelve { reiniciar } para que las flechas reinicien la cuenta: si la
     * persona acaba de mover el riel, no se le mueve otra vez al instante.
     */
    var INTERVALO = 4000;
    var ESPERA_TRAS_TOCAR = 8000;

    function montarRotacion(fila, riel) {
        var nada = { reiniciar: function () {} };
        if (MENOS_MOVIMIENTO && MENOS_MOVIMIENTO.matches) { return nada; }

        var temporizador = null;
        var pausadoPorPersona = false;
        var encima = false;
        var enfocado = false;
        var visible = false;
        var tocadoHasta = 0;

        var boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'pth-pausa';
        boton.hidden = true;
        boton.innerHTML =
            '<svg class="pth-ico-pausa" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor"/></svg>' +
            '<svg class="pth-ico-play" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
        fila.appendChild(boton);

        function seDesborda() {
            return riel.scrollWidth - riel.clientWidth > 1;
        }

        function pintarBoton() {
            boton.hidden = !seDesborda();
            boton.setAttribute('aria-pressed', pausadoPorPersona ? 'true' : 'false');
            boton.setAttribute('aria-label', (pausadoPorPersona ? 'Reanudar' : 'Pausar') + ' el avance automático de esta fila');
            boton.classList.toggle('is-pausado', pausadoPorPersona);
        }

        function debeRotar() {
            return !pausadoPorPersona && !encima && !enfocado && visible &&
                !document.hidden && seDesborda() && Date.now() >= tocadoHasta;
        }

        function avanzar() {
            var maximo = riel.scrollWidth - riel.clientWidth;
            if (riel.scrollLeft >= maximo - 1) {
                riel.scrollTo({ left: 0, behavior: suave() });
            } else {
                // Una sola tarjeta por paso: se alcanza a leer cada una.
                var tarjeta = riel.querySelector('.pth-card');
                var estilo  = window.getComputedStyle(riel);
                var hueco   = parseFloat(estilo.columnGap || estilo.gap) || 0;
                var ancho   = tarjeta ? tarjeta.getBoundingClientRect().width + hueco : riel.clientWidth;
                riel.scrollBy({ left: ancho, behavior: suave() });
            }
        }

        function programar() {
            window.clearTimeout(temporizador);
            temporizador = null;
            pintarBoton();
            if (!debeRotar()) {
                // Si solo falta que pase la espera tras tocar, se vuelve a mirar entonces.
                var resta = tocadoHasta - Date.now();
                if (resta > 0 && !pausadoPorPersona) {
                    temporizador = window.setTimeout(programar, resta + 50);
                }
                return;
            }
            temporizador = window.setTimeout(function () {
                avanzar();
                programar();
            }, INTERVALO);
        }

        function tocado() {
            tocadoHasta = Date.now() + ESPERA_TRAS_TOCAR;
            programar();
        }

        boton.addEventListener('click', function () {
            pausadoPorPersona = !pausadoPorPersona;
            programar();
        });

        fila.addEventListener('mouseenter', function () { encima = true; programar(); });
        fila.addEventListener('mouseleave', function () { encima = false; programar(); });
        // Solo el foco de teclado pausa: tras un clic con mouse en pausa/play
        // el foco se queda en el boton y el riel no volvia a avanzar.
        fila.addEventListener('focusin', function (ev) { enfocado = focoDeTeclado(ev.target); programar(); });
        fila.addEventListener('focusout', function (ev) {
            if (!fila.contains(ev.relatedTarget)) { enfocado = false; programar(); }
        });

        // Gestos de la persona sobre el riel: dedo, rueda o arrastre.
        riel.addEventListener('touchstart', tocado, { passive: true });
        riel.addEventListener('wheel', tocado, { passive: true });
        riel.addEventListener('pointerdown', tocado);

        document.addEventListener('visibilitychange', programar);

        if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entradas) {
                visible = entradas[0].isIntersecting;
                programar();
            }, { threshold: .4 }).observe(riel);
        } else {
            visible = true;
        }

        if (window.ResizeObserver) {
            new window.ResizeObserver(pintarBoton).observe(riel);
        }

        programar();

        return { reiniciar: tocado };
    }

    /*
     * Previsualizacion al pasar el cursor.
     *
     * Hoy esta dormida: ninguna tarjeta emite data-pth-clip todavia, asi que
     * este bloque no llega a hacer nada. Queda escrito y probado para que,
     * cuando DG entregue los verticales, baste con emitir el atributo desde
     * _card.php.
     *
     * Pendiente cuando llegue ese momento: los videos del CDN se sirven en HLS
     * (index.m3u8) y solo Safari lo reproduce de forma nativa. Para el resto
     * hara falta o una copia MP4 corta de la propia previsualizacion —lo
     * razonable, porque son segundos— o hls.js, que son ~150 KB.
     */
    function montarPrevisualizacion(fila) {
        if (!HAY_CURSOR || !HAY_CURSOR.matches) { return; }
        if (MENOS_MOVIMIENTO && MENOS_MOVIMIENTO.matches) { return; }

        var enlaces = fila.querySelectorAll('.pth-card-link[data-pth-clip]');

        for (var i = 0; i < enlaces.length; i++) {
            (function (enlace) {
                var medio = enlace.querySelector('.pth-card-media');
                if (!medio) { return; }

                var temporizador = null;
                var video        = null;

                enlace.addEventListener('mouseenter', function () {
                    // Medio segundo: evita disparar descargas al barrer la fila.
                    temporizador = window.setTimeout(function () {
                        if (video) { return; }

                        video = document.createElement('video');
                        video.className = 'pth-card-clip';
                        video.src         = enlace.getAttribute('data-pth-clip');
                        video.muted       = true;
                        video.loop        = true;
                        video.playsInline = true;
                        video.preload     = 'none';
                        video.setAttribute('aria-hidden', 'true');

                        medio.appendChild(video);

                        var promesa = video.play();
                        if (promesa && promesa.then) {
                            promesa.then(function () {
                                video.classList.add('pth-clip-visible');
                            }).catch(function () {
                                // Autoplay bloqueado: se queda la portada.
                                limpiar();
                            });
                        }
                    }, 500);
                });

                enlace.addEventListener('mouseleave', limpiar);

                function limpiar() {
                    window.clearTimeout(temporizador);
                    if (!video) { return; }
                    video.pause();
                    if (video.parentNode) { video.parentNode.removeChild(video); }
                    video = null;
                }
            })(enlaces[i]);
        }
    }

    function arrancar() {
        var filas = document.querySelectorAll('[data-pth-riel]');
        for (var i = 0; i < filas.length; i++) {
            montarRiel(filas[i]);
            montarPrevisualizacion(filas[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', arrancar);
    } else {
        arrancar();
    }
})();
